export const AUTHEN_LOGIN_LINE_REQ = '@AUTHEN/LOGIN_LINE_REQ';
export const AUTHEN_LOGIN_LINE_SUCCESS = '@AUTHEN/LOGIN_LINE_SUCCESS';
export const AUTHEN_LOGIN_LINE_FAIL = '@AUTHEN/LOGIN_LINE_FAIL';
export const AUTHEN_LOGOUT_LINE_REQ = '@AUTHEN/LOGOUT_LINE_REQ';
export const AUTHEN_LOGOUT_LINE_SUCCESS = '@AUTHEN/LOGOUT_LINE_SUCCESS';
export const AUTHEN_LOGOUT_LINE_FAIL = '@AUTHEN/LOGOUT_LINE_FAIL';
